












































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import FiltroDenuncias from '@/model/filtros/FiltroDenuncias'
import {
  greaterOrEquals,
  lengthAnio,
  maxLength,
  required,
} from '@/utils/ValidationUtil'
import FechaSelect from '@/components/commons/FechaSelect.vue'
import { ESTADO_DENUNCIA } from '@/api/StaticApi'
import { mapToSelect } from '@/utils/SelectUtil'
import { buildCompareFn } from '@pjn/utils/array'
@Component({ components: { FechaSelect } })
export default class FiltrosDenuncias extends Vue {
  @Prop()
  private filtro: FiltroDenuncias

  @Prop({ default: false, type: Boolean })
  private disabled

  form(): Vue & { validate: () => boolean; resetValidation(): void } {
    return this.$refs.form as Vue & {
      validate: () => boolean
      resetValidation(): void
    }
  }
  private rules = {
    required,
    maxLength500: maxLength(500),
    lengthAnio,
    greaterOrEquals2021: greaterOrEquals((): number => 2021),
    maxLength6: maxLength(6),
  }
  private itemsEstadosSelect: any = [
    { text: 'Todos', value: 'TODOS' },
    ...mapToSelect(ESTADO_DENUNCIA).sort(buildCompareFn({ field: 'text' })),
  ]

  validate() {
    return this.form().validate()
  }
  applyFilter(tipo: string) {
    this.$emit('applyFilter', tipo)
  }

  resetValidation() {
    this.form().resetValidation()
  }
}
